<template>
  <Suspense>
    <RouterView v-slot="{ Component }">
      <AppLayout class="text-on-surface" :lang="locale">
        <component :is="Component" />
        <BaseSnackBar />
      </AppLayout>
    </RouterView>
  </Suspense>
  <CustomTooltip />
</template>
<script setup lang="ts">
  import { RouterView } from 'vue-router'
  import CustomTooltip from './core/components/base/tooltip/CustomTooltip.vue'
  import AppLayout from './core/components/layouts/AppLayout.vue'
  import BaseSnackBar from './core/components/base/snack/BaseSnackBar.vue'
  import { useI18n } from 'vue-i18n'

  const { locale } = useI18n()
</script>
